import React from 'react';
import {Outlet} from "react-router-dom";

import css from './StatisticsPage.module.css';
import {TitleMenuStatistics} from "../../components/statistickSection";


const StatisticsPage = () => {
    return (
        <section className={css.wrap}>
            <section className={css.menuBlock}>
                <TitleMenuStatistics/>
            </section>

            <section className={css.outletBlock}>
                <Outlet/>
            </section>
        </section>
    );
};

export {StatisticsPage};